import styled from 'styled-components/macro';

export const StyledPage = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  background-color: #f5f5f5;
`;

export const StyledWrapper = styled.div`
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
